// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"be7061c7","56":"db23be3c","57":"6cd477bb","124":"f32ac6dc","449":"3ee383dd","453":"87e45203","585":"10569784","660":"dff304d2","697":"31498dcd","712":"e54336ea","819":"9d9f3014"}[chunkId] + ".chunk.js";
};